<template>
  <v-card>
    <v-container>
      <v-toolbar elevation="0">
        <v-toolbar-title class="primary--text"><h2>New Area</h2></v-toolbar-title>
      </v-toolbar>
      <v-row class="px-4">
        <v-col cols="12">
          <v-text-field
              v-model="area.name"
              label="Area Name"
          >
          </v-text-field>
        </v-col>
        <v-col cols="6" class="pr-4">
          <v-text-field
              v-model="area.postalCodeStart"
              label="Postal Code Start"
          >
          </v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
              v-model="area.postalCodeEnd"
              label="Postal Code End"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12">
          <v-row justify="end" class="px-4">
            <v-btn class="primary" v-on:click="submitNewArea">
              Next
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "AddArea",
  props: {
    locationChangeCallback: Function
  },
  data() {
    return {
      area: {
        name: '',
        postalCodeStart: '',
        postalCodeEnd: ''
      }
    }
  },
  methods: {
    submitNewArea() {
      this.locationChangeCallback({
        ...this.area,
        postalCodeStart: Number.parseInt(this.area.postalCodeStart),
        postalCodeEnd: Number.parseInt(this.area.postalCodeEnd)
      });
    }
  }
}
</script>

<style scoped>

</style>